import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const valueBullets = [{
  emoji: '📄',
  text: '100% digital (PDF + planificador imprimible)'
}, {
  emoji: '⚡',
  text: 'Acceso en 5 min'
}, {
  emoji: '👶',
  text: 'Para hijos de 3 a 12 años'
}, {
  emoji: '⏱️',
  text: 'Actividades de 5, 15 y 30 minutos'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream-100" data-id="element-91" data-mp="129h19owp12dy">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-terracotta-100/70 blur-2xl" data-id="element-92" data-mp="128pgza8jqr2z" />
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/2 h-80 w-80 rounded-full bg-sage-100/80 blur-3xl" data-id="element-93" data-mp="sarv2te5t6dj" />

      <div className="relative mx-auto max-w-3xl px-5 pb-16 pt-12 sm:px-8 sm:pb-24 sm:pt-16" data-id="element-94" data-mp="nbopn7u9oy51">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center" data-id="element-95" data-mp="3d2bj5ngruvuh">
          <span className="inline-flex items-center gap-2 rounded-full border border-bark-800/10 bg-cream-50 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-bark-600 shadow-sm" data-id="element-96" data-mp="3j6obvk13emq3">
            👨‍👩‍👧 LIBROFY.STORE™
          </span>

          <h1 className="mt-7 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-bark-900 sm:text-5xl md:text-6xl" data-id="element-97" data-mp="3e8efx77jni3f">
            Todo tu sistema de conexión familiar.
            <span className="mt-2 block text-terracotta-500" data-id="element-98" data-mp="3599f1u8ifco3">Listo. Desde hoy.</span>
          </h1>

          <p className="mt-6 font-display text-lg font-medium text-bark-600 sm:text-xl" data-id="element-99" data-mp="2qkda461r2frp">
            KIT PADRES PRESENTES 
          </p>

          

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-bark-600 sm:text-lg" data-id="element-100" data-mp="2vgu075sif47f">
            El sistema N°1 para padres y madres que trabajan mucho y no quieren perderse la infancia
            de sus hijos
          </p>

          <p className="mx-auto mt-5 max-w-2xl rounded-3xl bg-cream-50/80 px-5 py-4 text-sm leading-relaxed text-bark-600 shadow-sm sm:text-base" data-id="element-101" data-mp="s2jnhxye22k1">
            Rutinas + guiones + planificador listos para usar. Sin improvisar. Sin culpa. Sin perder
            más domingos pensando <span className="italic" data-id="element-102" data-mp="i9vpizvo9sjq">“debería estar más presente”</span>.
          </p>
        </motion.div>

        <motion.ul initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.08,
            delayChildren: 0.25
          }
        }
      }} className="mx-auto mt-9 grid max-w-xl gap-3 sm:grid-cols-2" data-id="element-103" data-mp="1b0vw9ile1af3">
          {valueBullets.map(bullet => <motion.li key={bullet.text} variants={{
          hidden: {
            opacity: 0,
            y: 12
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="flex items-center gap-3 rounded-2xl border border-bark-800/[0.08] bg-cream-50 px-4 py-3 text-left text-sm font-medium text-bark-800" data-id="element-104" data-mp="x14o3yhjyo90">
              <span aria-hidden="true" className="text-lg" data-id="element-105" data-mp="21a4txwhwuk6i">
                {bullet.emoji}
              </span>
              <span data-id="element-106" data-mp="268y3xexznt1x">{bullet.text}</span>
            </motion.li>)}
        </motion.ul>

        <div className="mx-auto mt-9 max-w-md rounded-[2rem] bg-bark-900 p-6 shadow-warm-lg sm:p-8" data-id="element-107" data-mp="2b0ze8vblj9pb">
          <CTAButton href="#kit-completo" data-id="element-108" data-mp="2g0lr33niinxl">QUIERO MI KIT AHORA →</CTAButton>

          <p className="mt-5 text-center text-sm font-semibold text-cream-50 sm:text-base" data-id="element-109" data-mp="2kyn9rnh10l8j">
            <span aria-hidden="true" data-id="element-110" data-mp="2p0h6jko3p53f">💚 </span>+1000 padres{' '}
            <span className="font-normal text-cream-200/60" data-id="element-111" data-mp="2p1a5w0kqcsbj">ya lo tienen</span>
          </p>

          <p className="mt-3 text-center text-[0.7rem] font-medium leading-relaxed text-cream-200/50 sm:text-xs" data-id="element-112" data-mp="2tz1zr04xqoid">
            🛡️ Garantía 7 días · 🔒 Pago seguro · 💳 Mercado Pago · Tarjeta · Transferencia
          </p>
        </div>
      </div>
    </header>;
}